<ion-button
  id="startMatchButton"
  class="bar-button"
  *ngIf="itemStyle === 'button'"
  color="gray"
  (click)="startMatch()"
  expand="block"
  fill="clear"
>
  <div>
    <ion-icon name="play"></ion-icon>
    <span>Start</span>
  </div>
</ion-button>

<ion-item
  *ngIf="itemStyle === 'item'"
  button
  (click)="startMatch()"
  detail="false"
>
  <ion-label>{{ 'Start' | translate }}</ion-label>
  <ion-icon color="primary" slot="end" name="play"></ion-icon>
</ion-item>

<!-- <ion-button class="official" *ngIf="itemStyle === 'official'" color="gray" (click)="startMatch(true)" expand="block" fill="clear">
    <div>
        <ion-icon name="play"></ion-icon>
        <span>Start</span>
    </div>
</ion-button> -->

<ion-button
  *ngIf="itemStyle === 'official'"
  color="tertiary"
  (click)="startMatch(true)"
  expand="block"
  style="height: 150px"
>
  <ion-icon name="play"></ion-icon>
  <span>Start match</span>
</ion-button>